import { SINGLE } from "../../../constants/numbers.consts.js";
export const menuActionButtonSlotProps = {
    menu: {
        sx: {
            transform: "translateY(-8px)",
        },
        slotProps: {
            paper: {
                sx: {
                    backgroundColor: ({ vars }) => vars.palette.background.default,
                    borderRadius: ({ spacing }) => spacing(SINGLE),
                    minWidth: "280px",
                },
            },
        },
    },
};
export default menuActionButtonSlotProps;
